import {
  ActionType,
  ProColumns,
  ProFormMoney,
  ProFormSelect,
} from "@ant-design/pro-components";
import { DatePicker, Form, Space, message } from "antd";
import BoxContainer from "base/ui/components/BoxContainer";
import CustomButton from "base/ui/components/Button";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
// icons
import CustomSelect from "base/ui/components/CustomSelect";
import CustomProTable, {
  tablePagination,
} from "base/ui/components/CustomTable";
import * as Icon from "base/ui/components/Icons";
import PageWrapper from "pages/Components/PageWrapper";
import { SearchBox, SearchForm, SearchItem } from "pages/Components/SearchBox";
import { useTranslation } from "react-i18next";
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from "utils/constants";
import { CommonModel } from "services/Main/common_services";
import { ReportCTDAModel } from "services/Main/projectManagement_services";
import {
  commonPresenter,
  commonStore,
  projectManagementPresenter,
  projectManagementStore,
  uiStore,
} from "stores/root_store";
import { debounce } from "utils/debounce";
import { TableReportCTDA } from "../model";
import { formatNumber } from "utils/formatHelper";
import { AiOutlineDownload } from "react-icons/ai";
import { SearchModel } from "pages/model";
import { getAccountId, getPlantCode } from "utils/localStorageHelper";
import { useResizableColumns } from "utils/reportHelper";
import SaveReportForm from "pages/Components/reportForm";
import dayjs from "dayjs";
import { checkPermission, useCheckPermission } from "utils/permissionHelper";
import { dropdownTrueFalse2 } from "pages/Components/CriterialSearch";
import { commonMonths } from "pages/Components/CommonData";

const { RangePicker } = DatePicker;

export type TableListItem = {
  key: number;
  stt: number;
  congty: string;
  maDK: string;
  maCRM: string;
  tenKH: string;
  sdt: string;
  maSAP: string;
  tenSP: string;
  soSerial: string;
  donHang: string;
  phieuGH: string;
  phieuBH: string;
  tenBH: string;
  ngayDK: string;
  BHdenNgay: string;
  NNtruoc: string;
  solanNN: number;
  nhacNho: string;
};

const createProjectDetailReport = () => {
  return observer(() => {
    useCheckPermission("INDEX");
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title =
      t("page-title.project-details-report") + " - " + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();
    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------
    // dự án
    const [listProjects, setListProjects] = useState<CommonModel[]>([]);
    // Năm hoàn thiện
    const [listYearComplete, setListYearComplete] = useState<CommonModel[]>([
      { key: null, value: "--" + t("search-form.all") + "--" },
    ]);
    // Khu vực
    const [listRegion, setListRegion] = useState<CommonModel[]>([]);
    // tình trạng dự án
    const [listProjectStatus, setListProjectStatus] = useState<CommonModel[]>(
      []
    );
    // Loại hình
    const [listOpportunityType, setListOpportunityType] = useState<
      CommonModel[]
    >([]);
    // Tỉnh thành phố
    const [listTinh, setListTinh] = useState<CommonModel[]>([]);
    //   quận huyện
    const [listQuanHuyen, setListQuanHuyen] = useState<CommonModel[]>([]);
    // phường xã
    const [listPhuongXa, setListPhuongXa] = useState<CommonModel[]>([]);
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // data xác suất
    const [listProbability, setListProbability] = useState<CommonModel[]>([]);


    // theo dõi field "Thị trường" (market)
    const market = Form.useWatch('isForeignCustomer', form)
    //--- DATA TABLE ------------------------------------------------------------
    // data table báo cáo
    const [dataTable, setDataTable] = useState<TableReportCTDA[]>([]);

    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      accountId: getAccountId(),
      companyCode: getPlantCode(),
      profile: undefined,
      nvkd: undefined,
      region: undefined,
      status: undefined,
      type: undefined,
      province: undefined,
      ward: undefined,
      projectStatus: undefined,
      fromTime: undefined,
      toTime: undefined,
      fromYear: null,
      toYear: null,
      fromMonth: null,
      toMonth: null,
      fromValue: undefined,
      toValue: undefined,
      isTopInvestor: null,
      isForeignCustomer: 0,
    });

    // Loading
    const [exportLoading, setExportLoading] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const [disabledPickDate, setDisabledPickDate] = useState(false);

    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------
    // Lấy danh sách dự án
    const getListDataProject = async (key?: string) => {
      await commonPresenter.getListOpportunities(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListProjects(commonStore.commonRespone.data);
      }
    };
    const searchDataProject = debounce(getListDataProject, 500);

    // Lấy danh sách nhân viên kinh doanh
    const getListPersonInCharge = async (key?: string) => {
      await commonPresenter.getListPersonInCharge(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };

    // lấy danh sách khu vực
    const getListRegion = async (key: number) => {
      await commonPresenter.getListAreaByNation(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListRegion(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách tình trạng dự án
    const getListProjectStatus = async () => {
      await commonPresenter.getCommonDataByKey(
        commonStore,
        "Opportunity_Status"
      );
      if (commonStore.commonRespone.isSuccess) {
        setListProjectStatus(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách Loại hình
    const getListOpportunityType = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, "OpportunityType");
      if (commonStore.commonRespone.isSuccess) {
        setListOpportunityType(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách Tỉnh / thành phố
    const getListTinhThanhPho = async (area?: string) => {
      await commonPresenter.getListProvince(commonStore, area);
      if (commonStore.commonRespone.isSuccess) {
        setListTinh(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách Tỉnh/Thành cũ (bảng quận huyện, LevelType = Tỉnh/Thành cũ).
    // Chỉ lọc theo Khu vực, không phụ thuộc Tỉnh/Thành; không truyền Khu vực thì lấy tất cả.
    const getListQuanHuyen = async (area?: string) => {
      await commonPresenter.getListDistrict(commonStore, [], undefined, area);
      if (commonStore.commonRespone.isSuccess) {
        setListQuanHuyen(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách phường xã theo Tỉnh/Thành (sau sáp nhập không còn đi qua quận/huyện)
    const getListPhuongXa = async (tinhThanh: string[], key?: string) => {
      if (!tinhThanh.length) {
        setListPhuongXa([]);
        return;
      }
      await commonPresenter.getListWardByProvince(commonStore, tinhThanh, key);
      if (commonStore.commonRespone.isSuccess) {
        setListPhuongXa(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };
    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue("kyBaoCao", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("kyBaoCao", undefined);
      }
    };
    // danh sách chủ đầu tư
    const getListChuDauTu = async (key?: string) => {
      await commonPresenter.getListInvestors(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };
    // danh sách Nhà thiết kế
    const getListDesigner = async (key?: string) => {
      await commonPresenter.getListDesigner(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };
    // danh sách Tổng thầu
    const getListTongThau = async (key?: string) => {
      await commonPresenter.getListContracter(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };
    // danh sách Đối thủ
    const getListDoiThu = async (key?: string) => {
      await commonPresenter.getListCompetitor(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };

    // danh sách phòng ban
    const getListPhongBan = async (key?: string) => {
      await commonPresenter.getListDepartment(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        const tempData = cloneDeep(commonStore.commonRespone.data);
        return tempData.map((item) => ({
          label: item.value,
          value: item.key || "",
        }));
      }
      return [];
    };
    // danh sách xác suất
    const getListXacSuat = async (key?: string) => {
      await commonPresenter.getListOpportunitypercent(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListProbability(commonStore.commonRespone.data);
      }
    };
    // năm hoàn thiện
    const getListNamHoanThien = async () => {
      await commonPresenter.getListOpportunityyear(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        if (commonStore.commonRespone.data.length) {
          const tempData = commonStore.commonRespone.data.map((data) => ({
            key: JSON.parse(data.key + ""),
            value: data.value,
          }));
          setListYearComplete([
            { key: null, value: "--" + t("search-form.all") + "--" },
            ...tempData,
          ]);
        }
      }
    };

    const getDataTable = async (dataSearch: any) => {
      await projectManagementPresenter.getDataReportCTDA(
        projectManagementStore,
        { ...dataSearch, lang: uiStore.language }
      );
      if (projectManagementStore.reportCTDA.isSuccess) {
        const dataTemp = cloneDeep(projectManagementStore.reportCTDA.data);
        const total: any = dataTemp.pop();

        const t = dataTemp.map((item: ReportCTDAModel, index) => {
          if (index === dataTemp.length - 1) {
            Object.assign(total, {
              signDate: "Tổng giá trị của Spec & Thi công",
            });
            if (total) {
              item.constructions.push(total);
            }
          }
          const specs = item.specs.map((i, idx) => ({
            ...i,
            key: `${index + 1}.${idx + 1}`,
            signDate: i.signDate === "Tổng cộng" ? "Tổng Spec" : i.signDate,
          }));
          const constructions = item.constructions.map((i, idx) => ({
            ...i,
            key: `${index + 1}.${item.specs.length + idx + 1}`,
            signDate: i.signDate === "Tổng cộng" ? "Tổng Thi công" : i.signDate,
          }));

          Object.assign(item, {
            key: `${index + 1}`,
            children: [...specs, ...constructions],
          });
          return item;
        });
        setDataTable(t);
        return t;
      } else {
        message.error(projectManagementStore.reportCTDA.message);
        setDataTable([]);
        return [];
      }
    };

    useEffect(() => {
      (async () => {
        getListCommonDate();
        getListDataProject();
        getListPersonInCharge();
        getListRegion(0);
        getListProjectStatus();
        getListOpportunityType();
        getListTinhThanhPho();
        // Chưa chọn Khu vực: Tỉnh/Thành cũ hiển thị tất cả
        getListQuanHuyen();
        getListXacSuat();
        getListNamHoanThien();

      })();
    }, []);

    //-----ĐIỀU KIỆN SEARCH NĂM HOÀN THIỆN-------------------------------------------------------------------------------------------- //
    // required fromYear
    const [fromYearRequired, setFromYearRequired] = useState(false);
    // required toYear
    const [toYearRequired, setToYearRequired] = useState(false);

    useEffect(() => {
      form.validateFields(["fromYear"]);
    }, [fromYearRequired, form]);
    useEffect(() => {
      form.validateFields(["toYear"]);
    }, [toYearRequired, form]);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------

    const defaultColumn: ProColumns<TableReportCTDA>[] = [
      {
        title: t("zalo-notification.stt"),
        dataIndex: "stt",
        key: "stt",
        fixed: "left",
        width: 50,
        onCell: (_, index) => ({
          className: "text-center",
        }),
      },
      // Nhân viên kinh doanh
      {
        title: t("search-form.business-man"),
        dataIndex: "nvkd",
        key: "nvkd",
        fixed: "left",
        width: 180,
      },
      // Tên dự án
      {
        title: t("search-form.project-name"),
        dataIndex: "profileName",
        key: "profileName",
        fixed: "left",
        width: 200,
      },
      // Tiêu chuẩn bàn giao
      {
        title: t("project-report.tieu-chuan-bg"),
        dataIndex: "handoverFurniture",
        key: "handoverFurniture",
        width: 200,
      },
      // Tỉnh/thành phố
      {
        title: t("search-form.province"),
        dataIndex: "provinceName",
        key: "provinceName",
        width: 150,
      },
      // Loại hình
      {
        title: t("search-form.type"),
        dataIndex: "opportunityType",
        key: "opportunityType",
        width: 100,
      },
      // quy mô
      {
        title: t("project-report.quy-mo"),
        dataIndex: "scale",
        key: "scale",
        width: 100,
        onCell: (_, index) => ({
          className: "text-right",
        }),
      },
      // Chủ đầu tư
      {
        title: t("project-report.chu-dau-tu"),
        dataIndex: "investorName",
        key: "investorName",
        width: 150,
      },
      // Tư vấn-Thiết kê
      {
        title: t("project-report.tu-van"),
        dataIndex: "designName",
        key: "designName",
        width: 150,
      },
      // Nhóm/Loại
      {
        title: t("project-report.nhom-loai"),
        dataIndex: "typeOpportunity",
        key: "typeOpportunity",
        width: 150,
      },
      // Chi tiết sản phẩm
      {
        title: t("project-report.chi-tiet-sp"),
        dataIndex: "material",
        key: "material",
        width: 200,
      },
      // Ngày ký HĐ
      {
        title: t("project-report.ngay-ky-hd"),
        dataIndex: "signDate",
        key: "signDate",
        width: 250,
        onCell: (_, index) => ({
          className: _.signDate?.includes("Tổng") ? "font-bold" : "text-center",
        }),
      },
      // Trúng thầu
      {
        title: t("project-report.trung-thau"),
        dataIndex: "trungThau",
        key: "trungThau",
        width: 150,
        onCell: (_, index) => ({
          className:
            "text-right " +
            `${_.signDate?.includes("Tổng") ? "font-bold" : ""}`,
        }),
        // render: (text, record) =>
        //   text !== "-" ? formatNumber(Number(text), 0) : text,
      },
      // Rớt thầu
      {
        title: t("project-report.rot-thau"),
        dataIndex: "rotThau",
        key: "rotThau",
        width: 150,
        onCell: (_, index) => ({
          className:
            "text-right " +
            `${_.signDate?.includes("Tổng") ? "font-bold" : ""}`,
        }),
        // render: (text, record) =>
        //   text !== "-" ? formatNumber(Number(text), 0) : text,
      },
      // Thương hiệu khác
      {
        title: t("project-report.thuong-hieu-khac"),
        dataIndex: "otherBrand",
        key: "otherBrand",

        width: 150,
      },
      // Đối thủ
      {
        title: t("project-report.doi-thu"),
        dataIndex: "competitor",
        key: "competitor",

        width: 150,
      },
      // Tình trạng dự án
      {
        title: t("project-report.tt-du-an"),
        dataIndex: "opportunityStatus",
        key: "opportunityStatus",
        width: 150,
      },
      // xác suất
      {
        title: t("project-report.probability"),
        dataIndex: "opportunityPercentage",
        key: "opportunityPercentage",
        width: 150,
        onCell: (_, index) => ({
          className:
            "text-right "
        }),
        render(text) {
          return text !== '-' ? formatNumber(Number(text), 0) + '%' : text
        },
      },
      // Nội dung hoạt động
      {
        title: t("project-report.nd-hd"),
        dataIndex: "content",
        key: "content",

        width: 200,
      },
      // Thời gian bắt đầu
      {
        title: t("project-report.tg-bat-dau"),
        dataIndex: "startTime",
        key: "startTime",
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY",
        },
        onCell: (_, index) => ({
          className: "text-center",
        }),
        width: 150,
      },
      // Thời gian kết thúc
      {
        title: t("project-report.tg-ket-thuc"),
        dataIndex: "endTime",
        key: "endTime",
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY",
        },
        onCell: (_, index) => ({
          className: "text-center",
        }),
        width: 150,
      },
    ];
    const [columns, setColumns] = useState<ProColumns<TableReportCTDA>[]>(
      defaultColumn
    );
    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)

    // ============================================LƯU MẪU BÁO CÁO =========================================

    const tableRef = useRef<ActionType>();
    const constDataName = "BCChiTietDuAn";
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<TableReportCTDA>(
      columns,
      setColumns,
      constDataName
    );

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t("page-title.project-details-report"),
          },
        ]}
        extras={
          <>
            <CustomButton
              onClick={showDrawer}
              type="primary"
              color="#EFF4F9"
              className="!px-0 w-8"
            >
              <Icon.Filter className="!fill-primary py" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          {/* <Spin spinning={loading}> */}
          <CustomProTable<TableReportCTDA>
            className="[&_.ant-table-thead_th]:!text-center"
            bordered
            columns={columns}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            dataSource={dataTable}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              if (isSearch) {
                const data = await getDataTable({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                  },
                });
                if (Object.values(sort).length) {
                  setDataPaging({
                    ...dataPaging,
                    paging: {
                      ...dataPaging.paging,
                      orderBy:
                        Object.values(sort)[0] === "ascend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : undefined,
                      orderByDesc:
                        Object.values(sort)[0] === "descend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : undefined,
                    },
                  });
                }
                return {
                  data: data,
                  success: projectManagementStore.reportCTDA.isSuccess,
                };
              }
              return [];
            }}
            rowKey="key"
            expandable={{
              expandedRowKeys: [...dataTable.map((i) => i.key + "")],
              expandIcon: () => {
                return <></>;
              },
            }}
            onRow={(data, index) => ({
              className:
                data.signDate === "Tổng giá trị của Spec & Thi công"
                  ? "[&>td]:!bg-gradient-to-r [&>td]:!from-[#2667b233] [&>td]:!to-[#2667b233]"
                  : "",
            })}
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: projectManagementStore.reportCTDA.paging?.totalCount,
            }}
            columnsState={{
              value:
                Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {checkPermission("EXPORT") ? (
                  <CustomButton
                    size="middle"
                    loading={exportLoading}
                    onClick={async () => {
                      setExportLoading(true);
                      await projectManagementPresenter.exportExportReportCTDA(
                        { ...dataPaging, lang: uiStore.language }
                      );
                      setExportLoading(false);
                    }}
                    className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                    type="primary"
                  >
                    <AiOutlineDownload className="block text-base" />
                    <span className="block">{t("btn.export")}</span>
                  </CustomButton>
                ) : (
                  ""
                )}
              </>,
              // nút lưu mẫu bc
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
          {/* </Spin> */}
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          className="lg:!w-[50%]"
          onClose={onClose}
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              onClick={() => {
                form.submit();
              }}
              className="my-auto ml-auto"
              type="primary"
            >
              {t("btn.search")}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            initialValues={dataPaging}
            onFinish={(values) => {
              setIsSearch(true);

              const kyBaoCao = values["kyBaoCao"];
              const contryValue = values["isForeignCustomer"] === 1 ? false : values["isForeignCustomer"] === 2 ? true : null;

              let fromTime = undefined;
              let toTime = undefined;
              if (kyBaoCao) {
                fromTime = kyBaoCao[0].format("YYYY-MM-DD") || undefined;
                toTime = kyBaoCao[1].format("YYYY-MM-DD") || undefined;
              }
              setDataPaging({
                ...dataPaging,
                ...form.getFieldsValue(),
                fromTime: fromTime,
                toTime: toTime,
                isForeignCustomer: contryValue,
                paging: { ...dataPaging.paging, pageIndex: 1 },
              });
              tableRef.current?.reload();
              onClose()
            }}
          >
            {/* Chủ đầu tư  */}
            <SearchItem label={t('project-report.chu-dau-tu')}>
              <ProFormSelect
                mode="multiple"
                name={"investor"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListChuDauTu(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Top chủ đầu tư  */}
            <SearchItem name={"isTopInvestor"} label={t('search-form.top-investor')}>
              <CustomSelect
                options={dropdownTrueFalse2}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={false}
              />
            </SearchItem>
            {/* Thiết kế  */}
            <SearchItem label={t('search-form.designer')}>
              <ProFormSelect
                mode="multiple"
                name={"designer"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListDesigner(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Tổng thầu  */}
            <SearchItem label={t('search-form.contractor')}>
              <ProFormSelect
                mode="multiple"
                name={"contractor"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListTongThau(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Đối thủ  */}
            <SearchItem label={t('project-report.doi-thu')}>
              <ProFormSelect
                mode="multiple"
                name={"compertitor"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListDoiThu(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Thị trường */}
            <SearchItem start name={"isForeignCustomer"} label={t("search-form.market")}>
              {/* trong nước thì gửi false ngoài nước thì gửi true */}
              <CustomSelect
                options={[
                  {
                    label: "--" + t("search-form.all") + "--",
                    value: 0,
                  },
                  {
                    label: t("search-form.domestic"),
                    value: 1,
                  },
                  {
                    label: t("search-form.foreign"),
                    value: 2,
                  },
                ]}
                onChange={async (value) => {
                  const dataForm = form.getFieldsValue();
                  form.setFieldsValue({
                    ...dataForm,
                    region: undefined,
                    province: undefined,
                    district: undefined,
                    ward: undefined,
                  });
                  // Gọi tuần tự vì các API dùng chung commonStore.commonRespone.
                  await getListRegion(value);
                  // Đã bỏ Khu vực: Tỉnh/Thành cũ nạp lại tất cả, Phường/Xã chờ chọn Tỉnh/Thành
                  await getListQuanHuyen();
                  setListPhuongXa([]);
                }}
              />
            </SearchItem>
            {/* Khu vực */}
            <SearchItem name={"region"} label={t("search-form.area")}>
              <CustomSelect
                options={listRegion}
                onChange={async (value, option) => {
                  const dataForm = form.getFieldsValue();
                  form.setFieldsValue({
                    ...dataForm,
                    province: undefined,
                    district: undefined,
                    ward: undefined,
                  });
                  // Gọi tuần tự vì các API dùng chung commonStore.commonRespone.
                  await getListTinhThanhPho(option?.key);
                  // Tỉnh/Thành cũ đổ theo Khu vực, bỏ chọn Khu vực thì nạp lại toàn bộ
                  await getListQuanHuyen(option?.key);
                  setListPhuongXa([]);
                }}
                filterOption={false}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
              />
            </SearchItem>
            {/* Tỉnh/Thành phố - Tỉnh/Thành cũ không phụ thuộc trường này */}
            <SearchItem name={"province"} label={market === 2 ? t("search-form.country") : t("search-form.province")}>
              <CustomSelect
                mode="multiple"
                options={listTinh}
                onChange={async (value, option) => {
                  const dataForm = form.getFieldsValue();
                  form.setFieldsValue({
                    ...dataForm,
                    ward: undefined,
                  });
                  // Phường/Xã lấy theo Tỉnh/Thành
                  await getListPhuongXa(option.map((i: any) => i.key));
                }}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
              />
            </SearchItem>
            {/* Yêu cầu của BA => issue ACCRM-420 */}
            {/* 1. Chỉnh sửa tên Trường "Quốc gia" thành "Thị trường" */}
            {/* 2. Khi chọn Thị trường "Ngoài nước" thì sửa tên trường "Tỉnh/TP" thành "Quốc gia" và bỏ hai trường "Quận/Huyện" và "Phường/Xã" */}
            {
              market !== 2 && <>
                {/* Tỉnh/Thành cũ (trước sáp nhập là Quận/Huyện) - giữ field district, store lọc theo ProfileModel.DistrictId */}
                <SearchItem name={"district"} label={t("search-form.old-province")}>
                  <CustomSelect
                    mode="multiple"
                    options={listQuanHuyen}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </SearchItem>
                {/* Phường /Xã */}
                <SearchItem name={"ward"} label={t("search-form.wards")}>
                  <CustomSelect
                    mode="multiple"
                    options={listPhuongXa}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </SearchItem>
              </>
            }
            {/* Tên dự án */}
            <SearchItem
              start
              name={"profile"}
              label={t("search-form.project-name")}
            >
              <CustomSelect
                options={listProjects}
                mode="multiple"
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  searchDataProject(value);
                }}
              />
            </SearchItem>
            {/* Loại hình */}
            <SearchItem name={"type"} label={t("search-form.type")}>
              <CustomSelect
                mode="multiple"
                options={listOpportunityType}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
              />
            </SearchItem>

            {/* Tình trạng dự án */}
            <SearchItem
              name={"projectStatus"}
              label={t("search-form.project-status")}
            >
              <CustomSelect
                mode="multiple"
                options={listProjectStatus}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
              />
            </SearchItem>
            {/* Tình trạng  */}
            <SearchItem name={"status"} label={t("search-form.status")}>
              <CustomSelect
                options={[
                  {
                    label: "Trúng thầu",
                    value: "TRUNGTHAU",
                  },
                  {
                    label: "Rớt thầu",
                    value: "ROTTHAU",
                  },
                  {
                    label: "Cả hai",
                    value: "CAHAI",
                  },
                ]}
                allowClear
              />
            </SearchItem>
            {/* xác suất */}
            <SearchItem name={"opportunityPercentage"} label={"Xác suất"}>
              <CustomSelect
                options={listProbability}
                mode="multiple"
                allowClear
                fieldNames={{ label: "value", value: "key" }}
              />
            </SearchItem>
            {/* Nhan viên kinh doanh */}
            <SearchItem start label={t("search-form.business-man")}>
              <ProFormSelect
                mode="multiple"
                name={"nvkd"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListPersonInCharge(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Nhan viên Sales Admin */}
            <SearchItem label={"Nhân viên Sales Admin"}>
              <ProFormSelect
                mode="multiple"
                name={"personInChargeSalesAdmin"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListPersonInCharge(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Nhân viên Spec */}
            <SearchItem label={"Nhân viên Spec"}>
              <ProFormSelect
                mode="multiple"
                name={"personInChargeSpec"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListPersonInCharge(key.keyWords);
                }}
              />
            </SearchItem>
            {/* Phòng ban */}
            <SearchItem label={"Phòng ban"}>
              <ProFormSelect
                mode="multiple"
                name={"department"}
                debounceTime={500}
                showSearch
                allowClear
                rootClassName="!mb-0"
                request={async (key, props) => {
                  return await getListPhongBan(key.keyWords);
                }}
              />
            </SearchItem>

            <SearchItem label={"Năm hoàn thiện (Từ tháng/năm)"}>
              <Space.Compact className="w-full">
                <Form.Item noStyle name={"fromMonth"}>
                  <CustomSelect
                    options={[{ label: "--" + t("search-form.all") + "--", value: null }, ...commonMonths]}
                    onChange={(value) => {
                      form.setFieldValue("fromMonth", value);
                      if (value) {
                        setFromYearRequired(true);
                      } else {
                        setFromYearRequired(false);
                      }
                    }}
                    className="!w-1/2"
                    placeholder="Chọn tháng"
                  />
                </Form.Item>
                <Form.Item
                  noStyle
                  name={"fromYear"}
                  rules={[
                    {
                      required: fromYearRequired,
                      message: "Vui lòng nhập đầy đủ tháng và năm",
                    },
                  ]}
                >
                  <CustomSelect
                    options={listYearComplete}
                    fieldNames={{ label: "value", value: "key" }}
                    className="!w-1/2"
                    onChange={(value) => {
                      form.setFieldValue("fromYear", value);
                      if (!value && form.getFieldValue("fromMonth") !== null) {
                        setFromYearRequired(true);
                      } else {
                        setFromYearRequired(false);
                      }
                    }}
                    placeholder="Chọn năm"
                  />
                </Form.Item>
              </Space.Compact>
            </SearchItem>
            <SearchItem label={"Năm hoàn thiện (Đến tháng/năm)"}>
              <Space.Compact className="w-full">
                <Form.Item noStyle name={"toMonth"}>
                  <CustomSelect
                    options={[{ label: "--" + t("search-form.all") + "--", value: null }, ...commonMonths]}
                    onChange={(value) => {
                      form.setFieldValue("toMonth", value);
                      if (value) {
                        setToYearRequired(true);
                      } else {
                        setToYearRequired(false);
                      }
                    }}
                    className="!w-1/2"
                    placeholder="Chọn tháng"
                  />
                </Form.Item>
                <Form.Item
                  noStyle
                  name={"toYear"}
                  rules={[
                    {
                      required: toYearRequired,
                      message: "Vui lòng nhập đầy đủ tháng và năm",
                    },
                  ]}
                >
                  <CustomSelect
                    options={listYearComplete}
                    fieldNames={{ label: "value", value: "key" }}
                    onChange={(value) => {
                      form.setFieldValue("toYear", value);
                      if (!value && form.getFieldValue("toMonth") !== null) {
                        setToYearRequired(true);
                      } else {
                        setToYearRequired(false);
                      }
                    }}
                    className="!w-1/2"
                    placeholder="Chọn năm"
                  />
                </Form.Item>
              </Space.Compact>
            </SearchItem>

            <SearchItem label="Giá trị (tỷ)">
              <ProFormMoney
                label="Từ"
                customSymbol=" "
                name={"fromValue"}
                fieldProps={{ precision: 0 }}
              />
            </SearchItem>
            <SearchItem label=" ">
              <ProFormMoney
                label="Đến"
                customSymbol=" "
                name={"toValue"}
                fieldProps={{ precision: 0 }}
              />
            </SearchItem>

            {/* kỳ báo cáo (common)*/}
            <SearchItem
              start
              name={"commonKyBC"}
              label={t("search-form.report-time")}
            >
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledPickDate(option.key === "Custom" ? false : true);
                    await getDateByKey(option.key);
                  } else {
                    setDisabledPickDate(false);
                    form.setFieldValue("kyBaoCao", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* Kỳ báo cáo */}
            <SearchItem name={"kyBaoCao"} col2>
              <RangePicker
                disabled={disabledPickDate}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper >
    );
  });
};

export default createProjectDetailReport;
